import { render, staticRenderFns } from "./pageComparablesOthers.vue?vue&type=template&id=01105ea8&scoped=true&"
import script from "./pageComparablesOthers.vue?vue&type=script&lang=js&"
export * from "./pageComparablesOthers.vue?vue&type=script&lang=js&"
import style0 from "./pageComparablesOthers.vue?vue&type=style&index=0&id=01105ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01105ea8",
  null
  
)

export default component.exports